import React from "react";
import ReactTable from 'react-table-v6'
import Moment from 'moment';
import { Component, Fragment } from "react";

import {
	Card,
	CardBody,
	CardTitle,
	Col,
	Row,
	Progress,
	Input,
	ListGroup,
	ListGroupItem,
	Button,
	ButtonGroup,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
  Form,
  FormGroup,
  Label
} from 'reactstrap';

import update from 'react-addons-update';
import 'c3/c3.css';
import 'react-table-v6/react-table.css'
import { authenticationService } from '../../../jwt/_services';

class ApprovedUsersList extends React.Component {

	constructor(props) {
    super(props);

		const currentUser = authenticationService.currentUserValue;
		console.log('currentUser info: ' + JSON.stringify(currentUser));
		console.log('currentUser info: ' + JSON.stringify(currentUser.token));

    this.state = {
			approvedUsersData: [],
			obj: {},
			modal: false,
      modal2: false,
			modal5: false,
			availableApproveValue: 1,
			currentUser: JSON.parse(localStorage.getItem('currentUser')),
			approveValueOptions: [1, 2, 4, 8, 16, 32, 64, 128, 256, 512, 1024, 2048, 4096]
	  };

		this.toggle = this.toggle.bind(this);
		this.toggle2 = this.toggle2.bind(this);
		this.toggle5 = this.toggle5.bind(this);

  }

	async componentDidMount() {

    this.getApprovedUsersData();
	}

	toggle() {
	  this.setState({
	    modal: !this.state.modal
	  });
	}

  toggle2() {

	  this.setState({
	    modal2: !this.state.modal2
	  });
	}

	toggle5() {
	  this.setState({
	    modal5: !this.state.modal5
	  });
	}

	componentWillUnmount() {

	}

	goToRepairLog(id){
		window.location.href="/repair-log/"+id;
	}

	getApprovedUsersData = async () => {

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-approved-users";

		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: this.state.currentUser.jwtToken
			},
		});

		const body = await response.json();
		console.log("all approved users: " + JSON.stringify(body));

		if (body.status == 'Success') {
			this.setState({ approvedUsersData: body.response });

			var userData = body.response;

			for (var i=0; i<userData.length; i++) {

				if (userData[i].ApproveValue >= this.state.availableApproveValue) {
					this.setState({ availableApproveValue: (userData[i].ApproveValue)*2 });
					console.log("set availableApproveValue: " + (userData[i].ApproveValue)*2);
				}

			}

		} else {
      //ADD ERROR MESSAGE
    }

	};

	createApprovedUserSubmit = (event) => {
		event.preventDefault();

    let name = event.target.name.value;
    console.log(`name is:`, name);

    let email = event.target.email.value;
    console.log(`email is:`, email);

		let approveValue = event.target.approveValue.value;
    console.log(`approveValue is:`, approveValue);

		this.setState({
			modal5: !this.state.modal5
		})

    this.createApprovedUser(name, email, approveValue);
	}

  createApprovedUser = async (name, email, approveValue) => {

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"create-approved-user?Name="+name+"&UserEmail="+email+"&ApproveValue="+approveValue;

		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: this.state.currentUser.jwtToken
			},
		});

		const body = await response.json();
		console.log("create Approved user response: " + JSON.stringify(body));

		if (body.status == 'Success') {
			//this.setState({deviceInfo: body.response});
			//console.log("Device Registered First Name: " + this.state.deviceInfo.userInfo.UserAttributes.filter(attribute => attribute.Name.includes("given_name")).map(filteredName => (filteredName.Value)));
			//this.state.noDataForDevices = false;
			this.setState({ availableApproveValue: approveValue*2 });

      this.getApprovedUsersData();
		} else {
			//this.state.noDataForDevices = true;
		}

	};

	handleApprovedUsersSubmit = (event) => {
		event.preventDefault();
		let id = event.target.id.value;
    //console.log(`id:`, id);
	  let userID = event.target.userID.value;
    console.log(`userID is:`, userID);
    let name = event.target.name.value;
    console.log(`name is:`, name);
    let email = event.target.email.value;
    console.log(`email is:`, email);
		let approveValue = event.target.approveValue.value;
    console.log(`approveValue is:`, approveValue);

    //console.log(`role is:`, role);
		let newObj = JSON.parse(JSON.stringify(this.state.approvedUsersData));
    //console.log(`user copy is:`, newObj);
		//newObj[id] = [firstname, lastname, email, role];
    newObj[id] = {
			Name: name,
      Email: email,
			ApproveValue: approveValue,
    }
		this.setState({
			approvedUsersData: newObj,
			modal: !this.state.modal
		})
    console.log("saved approved user is:", this.state.approvedUsersData[id].Name);

    this.updateApprovedUser(userID, name, email, approveValue);
	}

  updateApprovedUser = async (userID, name, email, approveValue) => {

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"edit-approved-user?Name="+name+"&UserEmail="+email+"&ApproveValue="+approveValue+"&ApprovedUserID="+userID;

		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: this.state.currentUser.jwtToken
			},
		});

		const body = await response.json();
		console.log("Update category response: " + JSON.stringify(body));

		if (body.status == 'Success') {
			//this.setState({deviceInfo: body.response});
			//console.log("Device Registered First Name: " + this.state.deviceInfo.userInfo.UserAttributes.filter(attribute => attribute.Name.includes("given_name")).map(filteredName => (filteredName.Value)));
			//this.state.noDataForDevices = false;
		} else {
			//this.state.noDataForDevices = true;
		}

	};

	deleteApprovedUser = async () => {

		console.log("Delete User with Name: " + this.state.obj.Name);

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"delete-approved-user?ApprovedUserID="+this.state.obj.userID;

    console.log("Delete approved user url: " + url);

		const response = await fetch(url, {
			method: 'GET',
			headers: {
				Authorization: this.state.currentUser.jwtToken
			},
		});

		const body = await response.json();
		console.log("Delete approved user response: " + JSON.stringify(body.response));

		if (body.status == 'Success') {

			this.toggle2();
      this.getApprovedUsersData();

		} else {


		}

	};


  render() {

		const data = this.state.approvedUsersData.map((prop, key) => {

			//const buf = Buffer.from(prop.detailedissue, 'utf8');

			//buf.toString(); // 'Hello, World'

			return {
				id: key,
				userID: prop.ID,
        Name: prop.Name,
        Email: prop.Email,
				ApproveValue: prop.ApproveValue,
				actions: (
					// we've added some custom button actions
					<div className="text-center">
						{/* use this button to add a edit kind of action */}
						<Button
							onClick={() => {
								let obj = data.find(o => o.id === key);
                console.log('button obj: ' + obj);
								this.setState({
									obj: obj,
									modal: !this.state.modal,
								});
								//this.showVerification(obj);
							}}
							color="yellow"
							size="sm"
							round="true"
							icon="true"
						>
							<i className="fa fa-edit" />
						</Button>
						<Button
							onClick={() => {
								let obj = data.find(o => o.id === key);
                console.log('button obj: ' + obj);
								this.setState({
									modal2: !this.state.modal2,
									obj: obj
								});
							}}
							color="danger"
							size="sm"
							round="true"
							icon="true"
							className="ml-2"
						>
							<i className="fa fa-trash-alt" />
						</Button>
						{/* use this button to remove the data row */}
						{/* <Button
							onClick={() => {
								let obj = data.find(o => o.id === key);
                console.log('button obj: ' + obj);
								this.setState({
									modal2: !this.state.modal2,
									obj: obj
								});
							}}
							color="danger"
							size="sm"
							round="true"
							icon="true"
							className="ml-2"
						>
							<i className="fa fa-trash-alt" />
						</Button> */}
					</div>
				)
			};
		});

		return (
      <Fragment>
        <Card className="card-hover">
          <CardBody>
            <Row className="mb-3">
              <Col xs="6">
                <h1 style={{color:'#737782'}}>Approved Users</h1>
              </Col>
              <Col xs="6">
                <Button className="float-right" color="yellow" onClick={this.toggle5}>Create Approved User</Button>
              </Col>
            </Row>
            <ReactTable
              style={{backgroundColor:'#000', padding:'10px', autocomplete: 'none'}}
              columns={[
                {
                  Header: "Name",
                  accessor: "Name",
                  style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									maxWidth: 450,
									minWidth: 200,
                  Cell: row => (
                      <div style={{ textAlign: "center" }}>{row.value}</div>
                    )
                },
                {
                  Header: "Email",
                  accessor: "Email",
                  style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									maxWidth: 450,
									minWidth: 200,
                  Cell: row => (
                      <div style={{ textAlign: "center" }}>{row.value}</div>
                    )
                },
								{
                  Header: "Approve Value",
                  accessor: "ApproveValue",
                  style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
									maxWidth: 450,
									minWidth: 100,
                  Cell: row => (
                      <div style={{ textAlign: "center" }}>{row.value}</div>
                    )
                },
                {
                  Header: "Actions",
                  accessor: "actions",
									style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
                  sortable: false,
									maxWidth: 200,
									minWidth: 80,
                  filterable: false
                }
              ]}
              defaultPageSize={10}
              sortable={true}
              showPaginationBottom={true}
              className="-striped -highlight"
              data={data}
              filterable
              getTrGroupProps={(state, rowInfo, column, instance) => {
                      if (rowInfo !== undefined) {
                          return {
                              onClick: (e, handleOriginal) => {
                                console.log('It was in this row:', rowInfo)
                                console.log('with ID:', rowInfo.original.categoryID);

                                //this.goToRepairLog(rowInfo.original.repairId);
                              },
                              style: {
                                  cursor: 'pointer'
                              }
                          }
                      }}
                  }
            />
          </CardBody>
        </Card>
  			<div>
  				<Modal isOpen={this.state.modal} toggle={this.toggle}>
  					<ModalHeader toggle={this.toggle}>Edit Approved User</ModalHeader>
  					<ModalBody>
  						<Form onSubmit={this.handleApprovedUsersSubmit}>
  							<Input type="hidden" name="id" id="id" defaultValue={this.state.obj.id}/>
  							<Input type="hidden" name="userID" id="userID" defaultValue={this.state.obj.userID}/>
								<FormGroup>
                  <Label for="name">Name</Label>
                  <Input type="text" name="name" id="name" defaultValue={this.state.obj.Name}/>
                </FormGroup>
                <FormGroup>
                  <Label for="email">Email</Label>
                  <Input type="text" name="email" id="email" defaultValue={this.state.obj.Email}/>
                </FormGroup>
								<FormGroup>
                  <Label for="approveValue">Approve Value</Label>
                  <Input type="text" name="approveValue" id="approveValue" defaultValue={this.state.obj.ApproveValue}/>
                </FormGroup>
  							<FormGroup>
  								<Button color="primary" type="submit">Save</Button>
  								<Button color="secondary" className="ml-1" onClick={this.toggle}>Cancel</Button>
  							</FormGroup>
  						</Form>
  					</ModalBody>
  				</Modal>
  				<Modal isOpen={this.state.modal2} toggle={this.toggle2}>
    				<ModalHeader toggle={this.toggle2}>Delete Approved User</ModalHeader>
    				<ModalBody>
  						<span>Are you sure you want to delete this Approved User?</span>
    				</ModalBody>
  					<ModalFooter>
  						<Button color="primary" onClick={this.deleteApprovedUser}>Yes</Button>
  						<Button color="secondary" className="ml-1" onClick={this.toggle2}>Cancel</Button>
  					</ModalFooter>
  			  </Modal>
  				<Modal isOpen={this.state.modal5} toggle={this.toggle5}>
  					<ModalHeader toggle={this.toggle5}>Create Approved User</ModalHeader>
  					<ModalBody>
  						<Form onSubmit={this.createApprovedUserSubmit}>
                <FormGroup>
                  <Label for="name">Name</Label>
                  <Input type="text" name="name" id="name"/>
                </FormGroup>
                <FormGroup>
                  <Label for="email">Email</Label>
                  <Input type="text" name="email" id="email"/>
                </FormGroup>
								<FormGroup>
                  <Label for="approveValue">Approve Value</Label>
									<Input style={{height: '30px', padding: '3px'}} type="select" name="approveValue" id="approveValue" defaultValue={this.state.availableApproveValue}>
									{this.state.approveValueOptions.map((approveValue, i) => (
										<Fragment>
										<option value={approveValue}>{approveValue}</option>
										</Fragment>
									))}
									</Input>
									{
										// <Input style={{height: '30px', padding: '3px'}} type="select" name="approveValue" id="approveValue" value={this.state.availableApproveValue}>
										// 	<option value={this.state.availableApproveValue}>{this.state.availableApproveValue}</option>
										// </Input>
									}
                </FormGroup>
  							<FormGroup>
  								<Button color="primary" type="submit">Save</Button>
  								<Button color="secondary" className="ml-1" onClick={this.toggle5}>Cancel</Button>
  							</FormGroup>
  						</Form>
  					</ModalBody>
  				</Modal>
  			</div>
      </Fragment>
		);
	}
}

export default ApprovedUsersList;
